<template>
	<table class="table-main etc">
		<thead>
			<tr>
				<th v-for="item in tableList" :key="item.id">
					{{ item.title }}
				</th>
			</tr>
		</thead>
		<tbody>
			<tr>
				<td v-for="item in tableList" :key="item.id">
					<template v-if="item.hasCount">
						<a
							v-if="item.href"
							class="link etc__text"
							:href="item.href"
							target="_blank"
							>{{ item.text }}</a
						>
						<p v-else class="etc__text">{{ item.text }}</p>
						<div v-if="item.id === 'review' && item.total">
							<button
								class="btn blue"
								@click="openListModal(item.id)"
							>
								{{ item.title }} 리스트 보기
							</button>
							<button
								class="btn blue"
								@click="openReviewerGradeModal"
							>
								리뷰어 등급 보기
							</button>
						</div>
						<button
							v-else-if="item.total"
							class="btn blue"
							@click="openListModal(item.id)"
						>
							{{ item.title }} 리스트 보기
						</button>
					</template>
					<button
						v-else-if="item.id === 'mission'"
						class="btn blue"
						@click="openListMissionModal()"
					>
						{{ item.title }} 리스트 보기 ({{ missionCount }}건)
					</button>
					<a v-else class="btn blue" :href="item.href" target="_blank"
						>{{ item.title }} 리스트 페이지 가기</a
					>
				</td>
			</tr>
		</tbody>
	</table>
</template>
<script>
	import { mapState } from 'vuex';

	export default {
		name: 'RegisterEtcInfo',
		props: {
			idRegister: {
				default: 0,
				type: Number,
			},
			nickname: {
				default: '',
				type: String,
			},
		},
		data() {
			return {
				reviewList: [],
				reviewTotal: 0,
				reviewCountInfo: '',
				productList: [],
				productTotal: 0,
				recommenderList: [],
				recommenderTotal: 0,
				missionList: [],
				missionCount: 0,
			};
		},
		computed: {
			...mapState('env', ['adminDomain']),
			tableList() {
				return [
					{
						id: 'inquiry',
						href: `/operation/cs-list?register=${this.idRegister}`,
						title: '1:1 문의',
						hasCount: false,
					},
					{
						id: 'review',
						href: `/review/list?idRegister=${this.idRegister}`,
						text: this.reviewCountInfo,
						total: this.reviewTotal,
						title: '리뷰',
						hasCount: true,
					},
					{
						id: 'mission',
						title: '미션',
						hasCount: false,
					},
					{
						id: 'product',
						href: `${this.adminDomain}/product/list_product?idRegister=${this.idRegister}`,
						text: this.productTotal,
						total: this.productTotal,
						title: '추천제품',
						hasCount: true,
					},
					{
						id: 'recommender',
						href: `/register/activated-list?nickname=${encodeURIComponent(this.nickname)}`,
						text: this.recommenderTotal,
						total: this.recommenderTotal,
						title: '추천인',
						hasCount: true,
					},
				];
			},
		},
		async mounted() {
			this.$store
				.dispatch('mission/getMissionList', this.idRegister)
				.then(({ eventMissionList, totalCount }) => {
					this.missionList = eventMissionList;
					this.missionCount = totalCount;
				})
				.catch(err => {
					console.error(err);
				});
			try {
				await Promise.all([
					this.getReview(),
					this.getProduct(),
					this.getRecommender(),
				]);
			} catch (err) {
				console.error(err);
			}
		},
		methods: {
			openListModal(id) {
				this.$store.commit('modal/toggleModal', {
					id: 'RegisterSimpleList',
					params: this[`${id}List`],
				});
			},
			openListMissionModal() {
				this.$store.commit('modal/toggleModal', {
					id: 'RegisterMissionList',
					params: this.missionList,
				});
			},
			openReviewerGradeModal() {
				this.$store.commit('modal/toggleModal', {
					id: 'ReviewerGrade',
					params: this.idRegister,
				});
			},
			async getReview() {
				const { data } = await this.$axiosAdmin2.get(
					`/api/registers/${this.idRegister}/reviews`
				);
				const { list, total } = data.data.reduce(
					(acc, item, idx) => {
						const display = item.isDisplay
							? '전시'
							: '<b class="font-red">비전시</b>';
						const evaluation = item.isEvaluation
							? '평가단'
							: '일반';
						let state;
						if (item.isDisplay === false) {
							acc.total[3]++;
							state = '<b class="font-red">비전시</b>';
						} else if (item.state === 'N') {
							acc.total[1]++;
							state = '정상';
						} else if (item.state === 'B') {
							acc.total[2]++;
							state = '<b class="font-red">블라인드</b>';
						} else if (item.state === 'C') {
							acc.total[4]++;
							state = '<b class="font-red">검수중</b>';
						}
						acc.list.push({
							id: item.idReview,
							title: `${idx + 1}. [${item.idProduct}]${item.brandTitle ? `[${item.brandTitle}]` : ''} ${item.productTitle}`,
							subTitles: [
								`전시여부 : ${display} | 평가단 여부 : ${evaluation} | 평점 : ${item.rating} | 상태 : ${state}`,
								item.modifiedDate &&
								item.modifiedDate !== item.createDate
									? `수정일시 : ${item.modifiedDate}`
									: `작성일시 : ${item.createDate}`,
							],
							text: item.reviewText.trim(),
							isBlind: item.state === 'B',
						});
						return acc;
					},
					{
						list: [],
						total: [data.contentTotal, 0, 0, 0, 0],
					}
				);

				this.reviewTotal = data.contentTotal;
				this.reviewList = list;
				this.reviewCountInfo = `등록 : ${total[0]}건 / 정상 : ${total[1]}건 / 블라인드 : ${total[2]}건 / 비전시 : ${total[3]}건 / 검수중 : ${total[4]}건`;
			},
			async getProduct() {
				const { data } = await this.$axiosAdmin2.get(
					`/api/registers/${this.idRegister}/wishes`
				);
				this.productTotal = data.contentTotal;
				this.productList = data.data.map((item, idx) => ({
					id: item.idProduct,
					title: `${idx + 1}. [${item.idProduct}] ${item.productTitle}`,
				}));
			},
			async getRecommender() {
				const { data } = await this.$axiosAdmin2.get(
					`/api/registers/${this.idRegister}/recommenders`
				);
				this.recommenderTotal = data.contentTotal;
				this.recommenderList = data.data.map((item, idx) => ({
					id: item.idRegister,
					title: `${idx + 1}. [${item.idRegister}] ${item.nickname}`,
				}));
			},
		},
	};
</script>
<style lang="scss" scoped>
	.etc {
		width: 100%;
	}

	.etc__text {
		display: block;
		padding: 0 8px;
		line-height: 30px;
		font-weight: 700;
	}
</style>
